// @flow
import React from "react"
import type { ID, EnumValue } from "data/enums/types"
import { preventDefault } from "common/events"
import ArrowIcon from "assets/icons/ArrowIcon"
import {
  Container,
  Arrow,
  StyledSelect,
  Option,
  EmptyOption,
} from "componentsStyled/Forms/Select"

type Props = {|
  options: EnumValue[],
  onChange: ID => mixed,
  placeholder?: string,
  value: ID,
  name?: string,
|}

const Select = ({
  options,
  placeholder,
  value,
  allowEmpty,
  onChange,
  name,
}: Props) => (
  <Container>
    <StyledSelect
      empty={value === ""}
      value={value}
      onClick={preventDefault}
      onChange={e => onChange(e.target.value)}
      name={name}
    >
      {placeholder &&
        <EmptyOption value="">{placeholder}</EmptyOption>
      }
      {options.map(o => (
        <Option key={o.id} value={o.id}>
          {o.name}
        </Option>
      ))}
    </StyledSelect>
    <Arrow>
      <ArrowIcon />
    </Arrow>
  </Container>
)

export default Select



// WEBPACK FOOTER //
// ./src/components/Select/index.js